import { addReport } from '@/api/evaluation'
import {
  deleteOfflineLogInfo,
  getAttackTypes,
  getComponent,
  getComponents,
  getDecodeRate,
  getDeviceAlarm,
  getDevices,
  getDropDown,
  getEncodeRate,
  getExecuteData,
  getExecuteType,
  getFailPayloadLog,
  getFailRate,
  getOfflineLogInfo,
  getProgress,
  getProgressPayload,
  getProgressPayloadLog,
  getProtectRate,
  getRiskRate,
  getSerial,
  getTagTreeSnapshotOptions,
  getTaskInfo,
  getTaskScore,
  getTemplateFailRate,
  updateInterceptStatus,
  getRequest,
  GetRequest,
  getLog,
  getFailedCaseList,
  getUnsentCaseList,
  getTaskResultLog,
  getVerifyResult,
  getRiskLevelDistribution,
  getAttackProtectionRanking,
  getDeviceProtectionRanking,
  getTemplateProtectionFailureRanking,
  getCaseLevelDistribution,
  getResourceFilterData,
} from '@/api/waf-create-task'
import { deleteList, getAttckList, getListDetailsElement } from '@/api/waf-list-task'
import { Message } from '@/components/message'
import { CreateReportParams } from '@/pages/evaluation/create-modal'
import { useRequest } from 'ahooks'

// 获取任务信息
export const useGetTaskInfo = () => {
  const { data, runAsync: run } = useRequest(params => getTaskInfo(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取任务信息失败')
    },
  })

  return [data?.data || [], run] as const
}

//获取进度条信息
export const useGetProgress = () => {
  const { data, runAsync: run } = useRequest(params => getProgress(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取进度信息失败')
    },
  })

  return [data?.data || [], run] as const
}

// 获取执行时间
export const useGetExecuteTime = () => {
  const { data, runAsync: run } = useRequest(params => getExecuteData(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取执行时间失败')
    },
  })

  return [data?.data?.execDate || [], run] as const
}

// 获取执行类型
export const useGetExecuteType = () => {
  const { data, runAsync: run } = useRequest(params => getExecuteType(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取执行类型失败')
    },
  })

  return [data?.data || [], run] as const
}

// 获取模板列表
export const useGetTemplateList = () => {
  const { data, runAsync: run } = useRequest(params => getDropDown(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取模板列表失败')
    },
  })

  return [data?.data?.items || [], run] as const
}

// 获取影响组件
export const useGetComponents = () => {
  const { data, runAsync: run } = useRequest(params => getComponents(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取影响组件失败')
    },
  })

  return [data?.data?.items || [], run] as const
}

// 获取关联安全设备
export const useGetDevices = () => {
  const { data, runAsync: run } = useRequest(params => getDevices(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取关联安全设备失败')
    },
  })

  return [data?.data?.items || [], run] as const
}

// 获取序列号
export const useGetSerial = () => {
  const { data, runAsync: run } = useRequest(params => getSerial(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '序列号获取失败')
    },
  })

  return [data?.data || [], run] as const
}

// 获取进度信息列表
export const useGetProgressList = () => {
  const { data, runAsync: run } = useRequest(params => getProgressPayload(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || 'Payload获取失败')
    },
  })

  return [data?.data?.items || [], run] as const
}

// 获取payload日志
export const useGetProgressPayloadLog = () => {
  const { runAsync: run } = useRequest(params => getProgressPayloadLog(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取Payload日志失败')
    },
  })

  return [run] as const
}

// 获取发送失败Payload日志
export const useGetFailPayloadLog = () => {
  const { runAsync: run } = useRequest(params => getFailPayloadLog(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取发送失败Payload日志失败')
    },
  })

  return [run] as const
}

// 获取攻击类型
export const useGetAttackType = () => {
  const { data, runAsync: run } = useRequest(params => getAttackTypes(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取攻击类型失败')
    },
  })
  return [data?.data.attackTypeList || [], run] as const
}

// 获取ATTCK
export const useGetAttck = () => {
  const { data, runAsync: run } = useRequest(params => getAttckList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取ATT&CK失败')
    },
  })

  return [data?.data?.items || [], run] as const
}

// 获取payload列表
export const useGetPayloadList = () => {
  const { runAsync: run, loading } = useRequest(params => getListDetailsElement(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取Payload列表失败')
    },
  })

  return [run, loading] as const
}

// 修改拦截状态
export const useUpdateInterceptStatus = () => {
  const { runAsync: run, loading } = useRequest(params => updateInterceptStatus(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '修改拦截状态失败')
    },
  })

  return [run, loading] as const
}

// 获取标签组列表
export const useGetTagTreeOptions = () => {
  const { runAsync: run, data } = useRequest(params => getTagTreeSnapshotOptions(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取标签列表失败')
    },
  })

  return [run, data?.data?.categoryList || []] as const
}

// 获取任务评分 （图表）
export const useGetTaskScore = () => {
  const { data, runAsync: run } = useRequest(params => getTaskScore(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取任务评分数据失败')
    },
  })

  return [data?.data || {}, run] as const
}

// 获取拦截失败率（图表）
export const useGetFailRate = () => {
  const { data, runAsync: run } = useRequest(params => getFailRate(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取拦截失败率失败')
    },
  })

  return [data?.data || {}, run] as const
}

// 获取解码失败率 (图表)
export const useGetDecodeRate = () => {
  const { data, runAsync: run } = useRequest(params => getDecodeRate(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取解码失败率失败')
    },
  })

  return [data?.data || {}, run] as const
}

// 获取攻击防护排名 （轮播）
export const useGetProtectRate = () => {
  const { data, runAsync: run } = useRequest(params => getProtectRate(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取拦截成功率数据失败')
    },
  })

  return [data?.data || {}, run] as const
}

// 获取解码能力排名 （轮播）
export const useGetEncodeRate = () => {
  const { data, runAsync: run } = useRequest(params => getEncodeRate(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取解码能力数据失败')
    },
  })

  return [data?.data?.items || [], run] as const
}

// 获取模板拦截成功率 （图表）
export const useGetTemplateFailRate = () => {
  const { data, runAsync: run } = useRequest(params => getTemplateFailRate(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取拦截失败率数据失败')
    },
  })

  return [data?.data?.templateRate || [], run] as const
}

// 获取设备告警统计 （图表）
export const useGetDeviceAlarm = () => {
  const { data, runAsync: run } = useRequest(params => getDeviceAlarm(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取设备告警统计失败')
    },
  })

  return [data?.data?.items || [], run] as const
}

// 获取危险等级分布 (图表)
export const useGetRiskRate = () => {
  const { data, runAsync: run } = useRequest(params => getRiskRate(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取危险等级分布失败')
    },
  })

  return [data?.data || {}, run] as const
}

// 获取影响组件分布 (图表)
export const useGetComponent = () => {
  const { data, runAsync: run } = useRequest(params => getComponent(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取影响组件失败')
    },
  })

  return [data?.data || {}, run] as const
}

// 获取离线日志导入信息
export const useGetOfflineLogImportInfo = () => {
  const { data, runAsync: run } = useRequest(params => getOfflineLogInfo(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '离线日志导入信息获取失败')
    },
  })

  return [data?.data || {}, run] as const
}

// 删除日志设备导入记录
export const useDeleteOfflineLogImportRecord = () => {
  const { runAsync: run, loading } = useRequest(params => deleteOfflineLogInfo(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '删除离线日志导入记录失败')
    },
  })

  return [run, loading] as const
}

// 生成报表
export const useAddReport = () => {
  const { runAsync: run, loading } = useRequest((data: CreateReportParams) => addReport(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '报表添加失败')
    },
  })

  return [run, loading] as const
}

// 删除任务
export const useDeleteList = () => {
  const { runAsync: run } = useRequest((data: { ids: string[] }) => deleteList(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '删除任务失败')
    },
  })

  return [run] as const
}

// payload列表详情抽屉数据
export const useGetRequest = () => {
  const {
    data,
    runAsync: run,
    loading,
  } = useRequest((params: GetRequest) => getRequest(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '详情获取失败')
    },
  })
  // console.log('data-----', data)
  return [data?.data || {}, run, loading] as const
}

export const useGetLog = () => {
  const { data, runAsync: run } = useRequest((params: GetRequest) => getLog(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '告警日志获取失败')
    },
  })
  return [data?.data?.items || [], run] as const
}

// 执行失败用例列表
export const useGetFailedCaseList = () => {
  const { data, runAsync: run } = useRequest(params => getFailedCaseList(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '执行失败用例列表获取失败')
    },
  })

  return [data?.data || [], run] as const
}

// 未执行用例列表
export const useGetUnsentCaseList = () => {
  const { data, runAsync: run } = useRequest(params => getUnsentCaseList(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '未执行用例列表获取失败')
    },
  })

  return [data?.data || [], run] as const
}

// 获取任务结果日志
export const useGetTaskResultLog = () => {
  const { data, runAsync: run } = useRequest(params => getTaskResultLog(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '任务结果日志获取失败')
    },
  })

  return [data?.data || [], run] as const
}

// 获取验证结果
export const useGetVerifyResult = () => {
  const { data, runAsync: run } = useRequest(params => getVerifyResult(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '验证结果获取失败')
    },
  })

  return [data?.data || [], run] as const
}

// 获取危险等级分布
export const useGetRiskLevelDistribution = () => {
  const { data, runAsync: run } = useRequest(params => getRiskLevelDistribution(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取危险等级分布失败')
    },
  })

  return [data?.data?.items || [], run] as const
}

// 获取攻击防护排名
export const useGetAttackProtectionRanking = () => {
  const { data, runAsync: run } = useRequest(params => getAttackProtectionRanking(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取攻击防护排名失败')
    },
  })

  return [data?.data?.items || [], run] as const
}

// 设备防护能力排名
export const useGetDeviceProtectionRanking = () => {
  const { data, runAsync: run } = useRequest(params => getDeviceProtectionRanking(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取设备防护能力排名失败')
    },
  })

  return [data?.data?.devices || [], run] as const
}

// 模板防护失效排名
export const useGetTemplateProtectionFailureRanking = () => {
  const { data, runAsync: run } = useRequest(
    params => getTemplateProtectionFailureRanking(params),
    {
      manual: true,
      onError: (err: any) => {
        Message.error(err?.msg || '获取模板防护失效排名失败')
      },
    },
  )

  return [data?.data?.list || [], run] as const
}

// 用例等级分布
export const useGetCaseLevelDistribution = () => {
  const { data, runAsync: run } = useRequest(params => getCaseLevelDistribution(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '用例等级分布获取失败')
    },
  })

  return [data?.data?.list || [], run] as const
}

// 获取用例分级筛选数据
export const useGetResourceFilterData = () => {
  const { data, runAsync: run } = useRequest(params => getResourceFilterData(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '用例分级筛选数据获取失败')
    },
  })

  return [data?.data || [], run] as const
}
